import { css } from 'emotion'

export const textBigStyles = css`
  font-size: 1.2em;
`
